import { render, staticRenderFns } from "./navbarchathistory.vue?vue&type=template&id=5c8c54de&"
import script from "./navbarchathistory.vue?vue&type=script&lang=js&"
export * from "./navbarchathistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports